import React from "react";
import { Box, Text, Table, Flex } from "@mantine/core";
import { IconZzz } from "@tabler/icons-react";
import styled from "styled-components";

const UserCounts = ({ timezones, size = "md" }) => {
  const sortedTimezones = timezones.sort((a, b) => b.offset - a.offset);
  const tableHeaders = [
    { label: "Timezone", key: "timezone" },
    { label: "When it'll send, in their time", key: "their_time" },
    { label: "Users", key: "count", align: "right" },
  ];

  return (
    <Box>
      <Table>
        <Table.Thead>
          <Table.Tr>
            {tableHeaders.map((header) => (
              <Table.Th key={header.key}>
                <Text fw={600} size="sm" align={header.align || "left"}>
                  {header.label}
                </Text>
              </Table.Th>
            ))}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {sortedTimezones.map((timezoneData, index) => (
            <StyledUserCount key={index} available={timezoneData.available}>
              <Table.Td>
                <Flex align="center" gap="xs">
                  {!timezoneData.available && (
                    <IconZzz size={16} color="var(--mantine-color-gray-3)" />
                  )}
                  <Text fw={600} size={size}>
                    {timezoneData.timezone}
                  </Text>
                </Flex>
              </Table.Td>
              <Table.Td>
                <Text size={size}>
                  {timezoneData.their_time} ({timezoneData.your_time})
                </Text>
              </Table.Td>
              <Table.Td>
                <Text align="right" size={size}>
                  {timezoneData.count}
                </Text>
              </Table.Td>
            </StyledUserCount>
          ))}
        </Table.Tbody>
      </Table>
    </Box>
  );
};

const StyledUserCount = styled(Table.Tr)`
  background: ${(props) =>
    props.available ? "transparent" : "var(--mantine-color-dark-6)"};
  color: ${(props) =>
    props.available ? "inherit" : "var(--mantine-color-gray-3)"};
`;

export default UserCounts;
